import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { CapacitorHttp } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';

import { DataRepositoryService } from '../../services/datarepository.service';
import { AccessFacadeService } from '../../services/facades/access-facade.service';
import { ServerSettingsFacadeService } from '../../services/facades/server-settings-facade.service';
import { LocatorService } from '../../services/locator.service';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { CLIENT_ID } from '../../shared/constants';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent],
  template: '<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent implements OnInit {
  public isLoading = false;

  constructor(
    private accessFacade: AccessFacadeService,
    private locatorService: LocatorService,
    private repo: DataRepositoryService,
    private serverSettingsFacade: ServerSettingsFacadeService,
    private translate: TranslateService,
  ) {}

  async ngOnInit(): Promise<void> {
    const logoutConfirmString = this.translate.instant('GENERAL.logout_confirm');

    if (window.confirm(logoutConfirmString)) {
      this.isLoading = true;
      this.locatorService.refetchLocators = true;
      this.accessFacade.removeUserToken();
      await this.repo.deleteDatabase();

      const authParams: any = {
        client_id: CLIENT_ID,
        post_logout_redirect_uri: `${this.serverSettingsFacade.snapshot?.cpad2Server}login`,
      };

      const configUrl = this.serverSettingsFacade.snapshot?.loginConfigUrl;
      if (configUrl) {
        authParams['configUrl'] = configUrl;
      }

      const queryString = new URLSearchParams(authParams).toString();

      const smartSettings = await this.fetchSmartSettings();

      if (smartSettings) {
        const logoutEndpoint = smartSettings['logout_endpoint'];
        window.location.href = `${logoutEndpoint}${queryString}`;
      }
    } else {
      history.back();
    }
  }

  private async fetchSmartSettings(): Promise<any | undefined> {
    try {
      const url = this.serverSettingsFacade.snapshot?.smartSettingsServer;
      if (!url) throw new Error('No SMART configuration URL provided');
      const response = await CapacitorHttp.get({ url });
      if (!response.data) throw new Error('Response data is empty');
      return response.data;
    } catch (e) {
      console.error('Error loading SMART configuration:', e);
      return undefined;
    }
  }
}
